import { useCallback, useEffect } from 'react'

interface IUseEscapeKeyPressParameters {
  cb: () => void
  condition: boolean
}

export const useEscapeKeyPress = ({ cb, condition }: IUseEscapeKeyPressParameters) => {
  /** -------------------- Methods ----------------------- */
  const handleEscKeyPress = useCallback(
    (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        cb()
      }
    },
    [cb]
  )

  /** -------------------- Effects ----------------------- */
  useEffect(() => {
    if (condition) {
      document.addEventListener('keyup', handleEscKeyPress)
    }

    return () => {
      document.removeEventListener('keyup', handleEscKeyPress)
    }
  }, [condition, cb, handleEscKeyPress])
}
